autoslash.createNamespace("autoslash.datepicker");
autoslash.register(autoslash.datepicker);

autoslash.datepicker.initialize = function(element) {
    "use strict";
    element.find("[data-autoslash-datepicker]").each(function(index, instance) {
        var numberOfMonths = $(instance).data("autoslash-datepicker-numberofmonths");
        var minDate = $(instance).data("autoslash-datepicker-mindate");
        var maxDate = $(instance).data("autoslash-datepicker-maxdate");
        $(instance).datepicker({
            numberOfMonths: numberOfMonths,
            dateFormat: "m/d/yy",
            minDate: minDate,
            maxDate: maxDate
        });
    });

    //Sync multiple pickers
    element.find("[data-autoslash-datepicker-type='pickup']").each(function (index, instance) {
        var date = $(instance).datepicker("getDate");
        if (date) {
            if ($("[data-autoslash-datepicker-type='dropoff']").datepicker("getDate") &&
                $("[data-autoslash-datepicker-type='dropoff']").datepicker("getDate") < date) {
                $("[data-autoslash-datepicker-type='dropoff']").datepicker("setDate", date);
            }
            $("[data-autoslash-datepicker-type='dropoff']").datepicker("option", "minDate", date);
        }

        $(instance).datepicker("option", "onSelect", function (date, instance) {
            if ($("[data-autoslash-datepicker-type='dropoff']").datepicker("getDate") &&
                $("[data-autoslash-datepicker-type='dropoff']").datepicker("getDate") < date) {
                $("[data-autoslash-datepicker-type='dropoff']").datepicker("setDate", date);
            }
            $("[data-autoslash-datepicker-type='dropoff']").datepicker("option", "minDate", date);
        });
    });

    //Enable date picker icons
    element.find("[data-autoslash-datepicker-icon]").each(function(index, instance) {
        $(instance).css("cursor", "pointer");
        var elementId = $(instance).data("autoslash-datepicker-icon");
        $(instance).click(function () {
           var element = $("#" + elementId);
            if (!element.is(':disabled')) {
                element.datepicker("show");
            }
        });
    });
}

// mobiscroll version

autoslash.createNamespace("autoslash.datepicker2");
autoslash.register(autoslash.datepicker2);

autoslash.datepicker2.initialize = function (element) {
    "use strict";
    element.find("[data-autoslash-datepicker2]").each(function (index, instance) {
        var minDate = $(instance).data("autoslash-datepicker2-mindate");
        var maxDate = $(instance).data("autoslash-datepicker2-maxdate");
        var isPickUp = $(instance).data("autoslash-datepicker2-type") === 'pickup';

        mobiscroll.calendar($(instance), {
            display: 'bubble',
            buttons: [],
            setOnDayTap: true,
            min: minDate,
            max: maxDate,
            yearChange: false,
            
            onSet: function (event, inst) {
                if (isPickUp) {
                    var selectedDate = inst.getVal();
                    var maxDate = new Date(selectedDate.getTime() + (310 * 24 * 60 * 60 * 1000)); // max is 310 days ahead of pick-up date

                    element.find("[data-autoslash-datepicker2-type='dropoff']").each(function(index, instance) {
                        let dropOff = mobiscroll.instances[instance.id];
                        if (dropOff) {
                            dropOff.option({
                                min: selectedDate,
                                max: maxDate
                            });

                            if (dropOff.getVal() && dropOff.getVal() < selectedDate) {
                                dropOff.setVal(selectedDate);
                            }
                        }
                    });
                }
            }
        });
    });
}